<success-screen bgImage="coinsCrypto" class="bp-modal mod-lg">
  <bp-modal-header header [title]="'send_success' | translate: [getTradable(transaction?.getCurrencyId()).getName()]">
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div content>
    <div class="success-content-inner">
      <div class="success-symbol mod-green mb-20 mt-70">
        <span class="bpi__icon-check large-weight"></span>
      </div>
      <div class="success-headline mb-15">{{ "send_successful" | translate }}</div>
      <p class="text-center mb-15 font-size-17 text-word-break">
        <span>{{ "send_success_text" | translate }}</span>
        <br />
        <strong>
          {{
          transaction?.getAmount()
          | tradable_precision_symbol
          : {
          id: transaction?.getCurrencyId(),
          currencies: [getTradable(transaction?.getCurrencyId())],
          dustThreshold: 0.0001
        }
        }}
      </strong>
      {{ "to_success_screen" | translate }}
      <strong>{{ getCorrectSendRecipient() }}</strong>
    </p>
    @if (showAddContactButton()) {
      <div class="mb-50 text-center">
        <a (click)="addAsContact()">{{ "add-as-contact" | translate }}</a>
      </div>
    }
    <div class="mb-50 text-center">
      <button (click)="goToWallet()" class="btn btn-primary btn-success-modal mod-middle" type="button">
        {{ "go-to-wallet" | translate }}
      </button>
    </div>
  </div>
  <div class="text-center">
    <button (click)="close()" class="btn btn-primary btn-success-modal" type="button">
      <strong>{{ "close" | translate }}</strong>
    </button>
  </div>
</div>
</success-screen>
